module.exports = __webpack_public_path__ + "img/img-9.d17dc0cc.png";